import { Box, styled } from '@mui/material';

const StyledAppBarButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  columnGap: theme.spacing(2)
}));

export default StyledAppBarButtonsContainer;
